import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';

export function PrivateRoute(): ReactNode {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Carry where they were trying to go. Without this, a hard refresh or a
    // shared deep link always dropped the person on the default landing page:
    // opening /agency/commitments and signing in delivered /agency instead,
    // with no sign anything had been lost.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
